<script setup lang="ts">
defineProps({
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const { t } = useTexts();
const appearance = useAppearanceStore();

const social = computed(() => {
  return normalizeStringJsonObject(appearance.appearance.social);
});

const socialItems = computed(() => {
  if (!social.value) return;

  const items = [];

  if (social.value.instagram) {
    items.push({
      name: 'instagram',
      icon: 'social/instagram',
      link: social.value.instagram,
      title: t('footer.instagram'),
    });
  }

  if (social.value.facebook) {
    items.push({
      name: 'facebook',
      icon: 'social/facebook',
      link: social.value.facebook,
      title: t('footer.facebook'),
    });
  }

  if (social.value.twitter) {
    items.push({
      name: 'X',
      icon: 'social/x',
      link: social.value.twitter,
      title: t('footer.twitter'),
    });
  }

  if (social.value.youtube) {
    items.push({
      name: 'youtube',
      icon: 'social/youtube',
      link: social.value.youtube,
      title: t('footer.youtube'),
    });
  }

  if (social.value.tiktok) {
    items.push({
      name: 'tiktok',
      icon: 'social/tiktok',
      link: social.value.tiktok,
      title: t('footer.tiktok'),
    });
  }

  if (social.value.whatsapp) {
    items.push({
      name: 'whatsapp',
      icon: 'social/whatsapp',
      link: social.value.whatsapp,
      title: t('footer.whatsapp'),
    });
  }

  if (social.value.telegram) {
    items.push({
      name: 'telegram',
      icon: 'social/telegram',
      link: social.value.telegram,
      title: t('footer.telegram'),
    });
  }

  return items;
});

const hasAnySocialItem = computed(() => {
  return socialItems.value && socialItems.value.length > 0;
});

function linkFilter(link: string) {
  // eslint-disable-next-line
  const regex = new RegExp('^(http|https)://', 'i');

  if (regex.test(link)) {
    return link;
  }

  return `https://${link}`;
}
</script>

<template>
  <div
    v-if="hasAnySocialItem"
    class="social"
  >
    <h2
      v-if="showTitle"
      class="footer-title"
    >
      <span>{{ $t('footer.follow_us') }}</span>
    </h2>

    <div class="flex items-center flex-col">
      <div :class="$style.socialIcons">
        <FooterItemsSocial
          v-for="item in socialItems"
          :key="item.name"
          :href="linkFilter(item.link)"
          :title="item.title"
        >
          <NuxtIcon
            aria-hidden="true"
            :name="item.icon"
          />
        </FooterItemsSocial>
      </div>
    </div>
  </div>
</template>

<style module lang="postcss">
.socialIcons {
  @apply flex items-stretch justify-start md:justify-center flex-nowrap gap-1 md:gap-2 w-full;
}
</style>
